/* eslint-disable */
import React from 'react';
import { PropTypes } from 'prop-types';

import { Icon } from '@ontruck/orc';
import { constants as errorConstants } from 'utils/errors';

const ErrorMessage = ({
  className,
  t,
  onClick,
  aditionalOptions,
  errorType,
}) => (
  <div className={className} data-testid="error-message">
    <div>
      <Icon className="icon" glyph="status-warning" />
    </div>
    {aditionalOptions ? (
      <span className="">{`${t(
        'Summary:error_message_aditional_options'
      )} `}</span>
    ) : (
      <span className="">
        {`${
          errorType === errorConstants.QUOTE_ERRORS.ROUTE
            ? t('Summary:route_message')
            : t('Summary:error_message')
        } `}
        <a className="link" onClick={onClick}>
          {t('Summary:error_link')}
        </a>
        {` ${t('Summary:error_call_ontruck')}`}
      </span>
    )}
  </div>
);

ErrorMessage.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  onClick: PropTypes.func,
};

ErrorMessage.defaultProps = {
  className: '',
  t: (t) => t,
  onClick: () => ({}),
};

export default ErrorMessage;
